let routerObj = [
    {
        path: 'selectOnlinePaper/:versionId/:userId',
        name: 'selectOnlinePaper',
        title: '在线作答预览',
        component: require('./components/selectOnlinePaper.vue')
    },
    {
        path: 'checkOnlinePaper',
        name: 'checkOnlinePaper',
        title: '在线作答详情',
        component: require('./components/checkOnlinePaper.vue')
    }
]


export default [
    {
        path: '/api',
        name: 'api',
        component: require('./views/page/api.vue'),
        children: routerObj
    }
]


// WEBPACK FOOTER //
// ./src/router.js